<template>
  <div class="language-selector">
    <slot />
    <img
      :src="selectedLanguageImage"
      alt="flag"
    />
    <img
      src="@/assets/images/common/header/arrow.svg"
      alt="down-arrow"
    />
    <select v-model="locale">
      <option value="en">English</option>
      <option value="de">Deutsch</option>
    </select>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  computed: {
    selectedLanguageImage() {
      return this.locale === 'de'
        ? require('@/assets/images/common/header/flag-de.svg')
        : require('@/assets/images/common/header/flag-en.svg');
    }
  },
  watch: {
    locale(newLocale) {
      localStorage.setItem('lang', newLocale);
    }
  }
};
</script>

<style scoped>
.language-selector {
  position: relative;
  display: flex;
  align-items: center;
  color: white;

  width: max-content;
}

.language-selector img {
  margin-left: 5px;
}

.language-selector select {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  color: white;
  opacity: 0;
  position: absolute;
  right: 0;

  cursor: pointer;
}
</style>
